import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Social from 'components/common/social';
import Join from 'components/HomeComponents/join'
import { SOCIAL_MEDIAS } from '../../constants/footer';

import './style.scss'
import SubscribeNewsletterForm from "../../forms/SubscribeNewsletterForm";

const AppFooter = ({ brandDetails, lang, loggedIn, history }, context) => {
  const socialMedias = brandDetails ? SOCIAL_MEDIAS[brandDetails.brandId] : [];
  const isRegisterPage = history.location.pathname === '/register';
  const isHomePage = history.location.pathname === '/';
  const urlTermsAndConditions = lang === 'es' ? 'https://www.sandos.com/es/terminos-y-condiciones-sandos4u' : 'https://www.sandos.com/terms-and-conditions-sandos4u';
  const urlPrivacyPolicy = lang === 'es' ? 'https://www.sandos.com/es/politica-de-privacidad' : 'https://www.sandos.com/privacy-policy';
  return (
    <Fragment>

      <Social mediaList={socialMedias || []} className="flex justify-center py-6 "/>
      <footer className="py-6 text-center uppercase">
        ©&nbsp;
        {moment().format('YYYY')}&nbsp;
        {brandDetails?.brandName}.&nbsp;
        {context.t('ALL RIGHTS RESERVED')}&nbsp;-&nbsp;
        <a href={urlTermsAndConditions} target="_blank" rel="noopener noreferrer" className="uppercase">
          {context.t('Terms and conditions')}
        </a>
        {/* <a href={`/terms-conditions/${lang}`} target="_blank" rel="noopener noreferrer" className="uppercase">
          {context.t('Terms and conditions')}
        </a> */}
        {/* &nbsp;-&nbsp; */}
        {/* <a href={`/legal-notice/${lang}`} target="_blank" rel="noopener noreferrer" className="uppercase">
          {context.t('Legal Notice')}
        </a> */}
        &nbsp;-&nbsp;
        <a href={urlPrivacyPolicy} target="_blank" rel="noopener noreferrer" className="uppercase">
          {context.t('Privacy Policy')}
        </a>

      </footer>
    </Fragment>
  )
}

AppFooter.contextTypes = {
  t: PropTypes.func.isRequired,
};

AppFooter.propTypes = {
  brandDetails: PropTypes.object,
  lang: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
};

export default AppFooter;
